var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLyrics = function SvgLyrics(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22V4q0-.824.587-1.412A1.93 1.93 0 0 1 4 2h11q.824 0 1.413.587Q17 3.176 17 4v.425q-.6.274-1.1.675a5.8 5.8 0 0 0-.9.9V4H4v12h11v-4q.4.5.9.9t1.1.675V16q0 .824-.587 1.413A1.93 1.93 0 0 1 15 18H6zm4-8h4v-2H6zm13-2a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 16 9q0-1.25.875-2.125A2.9 2.9 0 0 1 19 6q.274 0 .525.05.25.05.475.125V1h4v2h-2v6q0 1.25-.875 2.125A2.9 2.9 0 0 1 19 12M6 11h7V9H6zm0-3h7V6H6z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLyrics);
export { ForwardRef as ReactComponent };